import { useSyncExternalStore } from 'react';
import { currentDensity, currentTheme, subscribeAppearance } from './theme-mode.js';
import type { Density, Theme } from './tokens.js';

/** Server snapshot: no document to read, and light is the theme.css default. */
const serverTheme = (): Theme => 'light';
const serverDensity = (): Density => 'comfortable';

/** Re-renders when the theme changes — canvas/SVG code needs the value, not the class. */
export function useTheme(): Theme {
  return useSyncExternalStore(subscribeAppearance, currentTheme, serverTheme);
}

export function useDensity(): Density {
  return useSyncExternalStore(subscribeAppearance, currentDensity, serverDensity);
}
